module.exports = __webpack_public_path__ + "src/img/warning-gray.f8f25cc6.svg";